
// import React from 'react';
// import './Work.css';
// import whyChooseUsImg from '../../Assets/Work/why-choose-us-section.jpg';

// const Work = () => {
//   return (
//     <section className="work-section">
//       <div className="work-container">
//         <img
//           src={whyChooseUsImg}
//           alt="Why Choose Us"
//           className="work-image"
//           loading="lazy"
//         />
//       </div>
//     </section>
//   );
// };

// export default Work;

import React from "react";
import whyChooseUsImg from '../../Assets/Work/why-choose-us-section.jpg';
import whyChooseUsImgs from '../../Assets/Work/image-4-homepage-section (5).jpg';



export default function Work() {
  return (
    <>    <section className="py-5 bg-light">
      <div className="container">
        <div className="row g-4">


          <div className="col-12 col-md-6">
            <div className="card border-0 shadow h-100">
              <img
                src={whyChooseUsImgs}
                alt="Card 1"
                className="card-img-top img-fluid"
                loading="lazy"
              />
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="card border-0 shadow h-100">
              <img
                src={whyChooseUsImg}
                alt="Card 2"
                className="card-img-top img-fluid"
                loading="lazy"
              />
            </div>
          </div>

        </div>
      </div>
    </section></>

  );
}
